import { addEasing } from "@tsparticles/engine";
export async function loadEasingSinePlugin() {
    addEasing("ease-in-sine", (value) => 1 - Math.cos((value * Math.PI) / 2));
    addEasing("ease-out-sine", (value) => Math.sin((value * Math.PI) / 2));
    addEasing("ease-in-out-sine", (value) => -(Math.cos(Math.PI * value) - 1) / 2);
}
